import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { getClientInfo } from './customer';


const auth = getClientInfo();

export const msalConfig = {
    auth: {
        ...auth,
        redirectUri: '/builder'
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
            /**
             * Below you can configure MSAL.js logs. For more information, visit:
             * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
             */
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const postRequest = {
    scopes: [`api://${msalConfig.auth.clientId}/SiteGovern.Write`] // Add your required scopes
};

export const silentRequest = {
    loginHint: "Admin@sbqa01.ca"
};

export const msalApp = new PublicClientApplication(msalConfig);